import ApiService from "@/core/services/api.service";

// action types
export const FETCH_COMPANY_USERS = "fetchCompanyUsers";
export const FETCH_COMPANY_USER = "fetchCompanyUser";
export const STORE_COMPANY_USER = "storeCompanyUser";
export const UPDATE_COMPANY_USER = "updateCompanyUser";
export const DESTROY_COMPANY_USER = "destroyCompanyUser";
export const UPDATE_PASSWORD_USER_COMPANY = "updatePasswordUserCompany";
export const BAN_USER_COMPANY = "banUserCompany";
export const UNBAN_USER_COMPANY = "unbanUserCompany";
export const FETCH_COMPANY_BANNED_USERS = "fetchCompanyBannedUsers";

// mutation types
export const SET_COMPANY_USERS = "setCompanyUsers";
export const SET_COMPANY_USERS_PAGINATION = "setCompanyUsersPagination";
export const SET_COMPANY_USER = "setCompanyUser";
export const SET_COMPANY_BANNED_USERS = "setCompanyBannedUsers";
export const SET_COMPANY_BANNED_USERS_PAGINATION =
  "setCompanyBannedUsersPagination";

const state = {
  companyUsers: [],
  companyUsersPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  companyUser: {},
  companyBannedUsers: [],
  companyBannedUsersPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  companyUsers(state) {
    return state.companyUsers;
  },
  companyUsersPagination(state) {
    return state.companyUsersPagination;
  },
  companyUser(state) {
    return state.companyUser;
  },
  companyBannedUsers(state) {
    return state.companyBannedUsers;
  },
  companyBannedUsersPagination(state) {
    return state.companyBannedUsersPagination;
  }
};

const actions = {
  [FETCH_COMPANY_USERS](context, payload) {
    // debugger
    let params = {
      page: context.state.companyUsersPagination.currentPage,
      name: payload.name
    };
    if (typeof payload.cellphone == "string") {
      params.cellphone = payload.cellphone.replace(/^09/, "+989");
    }
    return new Promise((resolve, reject) => {
      ApiService.query("company/users", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_COMPANY_USERS, data.data);
          context.commit(SET_COMPANY_USERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_COMPANY_USER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query("profile", {
        params: {
          user: id
        }
      })
        .then(({ data }) => {
          context.commit(SET_COMPANY_USER, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_COMPANY_USER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("company/users", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_COMPANY_USER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("profile", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_COMPANY_USER](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`company/users/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  [UPDATE_PASSWORD_USER_COMPANY](context, payload) {
    let userId = payload[0];
    payload = payload[1];
    return ApiService.patch(`/company/users/${userId}/password`, payload).then(
      ({ data }) => {
        return data;
      }
    );
  },
  [BAN_USER_COMPANY](context, payload) {
    let userId = payload[0];
    payload = payload[1];
    return ApiService.patch(`/company/users/${userId}/ban`, payload).then(
      ({ data }) => {
        return data;
      }
    );
  },
  [UNBAN_USER_COMPANY](context, userId) {
    return ApiService.patch(`/company/users/${userId}/unban`).then(
      ({ data }) => {
        return data;
      }
    );
  },
  [FETCH_COMPANY_BANNED_USERS](context) {
    let params = {
      page: context.state.companyBannedUsersPagination.currentPage
    };
    return new Promise((resolve, reject) => {
      ApiService.query("company/banned-users", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_COMPANY_BANNED_USERS, data.data);
          context.commit(SET_COMPANY_BANNED_USERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_COMPANY_USERS](state, companyUsers) {
    state.companyUsers = companyUsers;
  },
  [SET_COMPANY_USERS_PAGINATION](state, data) {
    state.companyUsersPagination = data;
  },
  [SET_COMPANY_USER](state, companyUser) {
    state.companyUser = companyUser;
  },
  [SET_COMPANY_BANNED_USERS](state, companyBannedUsers) {
    state.companyBannedUsers = companyBannedUsers;
  },
  [SET_COMPANY_BANNED_USERS_PAGINATION](state, data) {
    state.companyBannedUsersPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
